module.exports = __webpack_public_path__ + "static/009.thumb-221c19926deb76668ddbfd7d7cd5078e.jpg";